import React, { useState } from 'react';
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bubble } from 'react-chartjs-2';
import { blue } from '@mui/material/colors';
import { useUpdateEffect } from 'react-use';
import { alpha } from '@mui/material';

ChartJS.register(LinearScale, PointElement, Tooltip, Legend);

const BubbleChart = ({ borderColor, textColor, data7 }) => {
  const R = 20;
  const [data, setData] = useState({
    datasets: [],
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          callback: (v, i, l) => {
            if (i === 0) return '자정';
            if (i === l.length - 1) return '시간대';
            if ((v / 20) % 1 === 0) return `${v / 20}시`;
            return '';
          },
          color: textColor,
        },
        grid: {
          color: borderColor,
        },
      },
      y: {
        ticks: {
          callback: (v, i, l) => {
            if (i === 0) return '낮음';
            if (i === l.length - 1) return '높음';
            return '';
          },
          color: blue[500],
          font: {
            size: 14,
            weight: 900,
          },
        },
        grid: {
          color: borderColor,
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => {
            const {
              dataIndex,
              raw: { y },
            } = tooltipItems[0];
            const rank = 25 - y / R;
            return `${rank}. ${dataIndex}시`;
          },
          label: (tooltipItems) => {
            const {
              raw: { r },
            } = tooltipItems;
            const total = parseInt(r ** 2, 10);
            return `사용량: ${total}건`;
          },
        },
      },
    },
  };

  useUpdateEffect(() => {
    // 최대값의 제곱근을 반지름(R)으로 사용
    if (data7 && data7.length) {
      const d = data7.map(({ _id: time, total, rank }) => ({
        x: parseInt(time, 10) * R,
        y: rank * R,
        r: Math.sqrt(total),
      }));

      setData({
        datasets: [
          {
            label: '시간대별 사용량',
            data: d,
            borderWidth: 1,
            borderColor: blue[500],
            backgroundColor: alpha(blue[500], 0.7),
            hoverBackgroundColor: blue[500],
          },
        ],
      });
    }
  }, [data7]);

  return (
    <Bubble
      options={options}
      data={data}
      onMouseDown={(e) => e.stopPropagation()}
    />
  );
};

export default BubbleChart;
